import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressEntry.html?raw';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class AddressEntry extends compose(_WidgetBaseSP) {
    templateString: any = template;

    isToDelete: boolean = false;

    addressMainContainer: HTMLElement;
    addressHeader: HTMLElement;
    addressButtonDelete: HTMLButtonElement;
    formData: MainCatalogTypes.Address_SaveData = {
        ID: "",
        is_new_status: null,
        is_to_delete: null,
        vt_address_backoffice_id: ""
    };

    setEntry(isNew: boolean, entry?: MainCatalogTypes.Address_LoadData): void {

        this.addressHeader.innerHTML = entry ? entry.gDisp_1 : "";

        if (isNew) {
            this.formData.is_new_status = true;
            this.formData.vt_address_backoffice_id = entry.ID
            this.UiModder.domClass.replace(this.addressMainContainer, "mds-bg-yellow", "mds-bg-green");
        } else {
            this.formData.ID = entry.ID;
            this.formData.is_new_status = false;
        }
        this.formData.is_to_delete = this.isToDelete;
        this.emit("Addresses_SerializeData");
    }

    _onClickButtonDelete(): void {

        this.isToDelete = !this.isToDelete;
        

        if (this.isToDelete) {
            
            if (this.formData.is_new_status === true) {

                this.emit("Addresses_Destroy");
                this.destroy();
                return;
            }

            this.UiModder.domClass.replace(this.addressMainContainer, "w3-pale-red", "mds-bg-green");
            this.addressButtonDelete.innerHTML = this.translations["GenericDialog__Btn_Cancel"];
        } else {

            this.UiModder.domClass.replace(this.addressMainContainer, "mds-bg-green", "w3-pale-red");
            this.addressButtonDelete.innerHTML = this.translations["General_Delete"];
        }
        this.formData.is_to_delete = this.isToDelete;
        this.emit("Addresses_SerializeData");

    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AddressEntry);